import { useState, useEffect } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const ORANGE = "#FF6B2B";
const ICONES = ["💰","💸","🏢","🛒","📱","💼","🔧","📊","🚗","✈️","🏠","⚡","📦","🍽️","💡","🎯","📣","🧾","🏦","👥"];
const CORES = ["#ef4444","#f59e0b","#10b981","#0ea5e9","#6366f1","#8b5cf6","#ec4899","#14b8a6","#f97316","#64748b"];
function corAba(tipo) { return tipo === "entrada" ? "#10b981" : "#ef4444"; }

export default function ModalCategorias({ onClose }) {
  const { theme } = useTheme();
  const [cats, setCats] = useState([]);
  const [aba, setAba] = useState("saida");
  const [novo, setNovo] = useState({ nome: "", cor: CORES[0], icone: ICONES[0] });
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [load, setLoad] = useState(false);

  const carregar = async () => {
    try { const { data } = await api.get("/categorias"); setCats(data.categorias || []); } catch {}
  };
  useEffect(() => { carregar(); }, []);

  const lista = cats.filter((c) => c.tipo === aba);

  const adicionar = async () => {
    if (!novo.nome.trim()) return;
    setLoad(true);
    try {
      await api.post("/categorias", { ...novo, tipo: aba });
      setNovo({ nome: "", cor: CORES[0], icone: ICONES[0] });
      await carregar();
    } catch (e) { alert(e.response?.data?.erro || "Erro ao criar"); }
    finally { setLoad(false); }
  };

  const salvarEdicao = async (id) => {
    try { await api.put(`/categorias/${id}`, editForm); setEditId(null); await carregar(); }
    catch (e) { alert(e.response?.data?.erro || "Erro ao salvar"); }
  };

  const excluir = async (id, nome) => {
    if (!window.confirm(`Excluir a categoria "${nome}"?`)) return;
    try { await api.delete(`/categorias/${id}`); await carregar(); }
    catch (e) { alert(e.response?.data?.erro || "Erro ao excluir"); }
  };

  const inp = { width: "100%", boxSizing: "border-box", background: theme.bgInput, border: `1.5px solid ${theme.border}`, borderRadius: 8, padding: "9px 12px", color: theme.text, fontSize: 13, outline: "none" };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={onClose}>
      <div style={{ background: theme.bgCard, borderRadius: 16, padding: 24, width: "100%", maxWidth: 560, maxHeight: "88vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,.3)" }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: theme.text }}>Gerenciar categorias</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: theme.textMuted, fontSize: 22 }}>×</button>
        </div>
        <div style={{ display: "flex", gap: 8, marginBottom: 18 }}>
          {[["saida", "💸 Saídas"], ["entrada", "💰 Entradas"]].map(([id, lbl]) => (
            <button key={id} onClick={() => setAba(id)} style={{ flex: 1, padding: "8px 0", borderRadius: 8, border: `1.5px solid ${aba === id ? corAba(id) : theme.border}`, background: aba === id ? corAba(id) + "18" : "transparent", color: aba === id ? corAba(id) : theme.textMuted, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>{lbl}</button>
          ))}
        </div>
        <div style={{ marginBottom: 20 }}>
          {lista.map((c) => (
            <div key={c._id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 10px", borderRadius: 8, border: `1px solid ${theme.border}`, marginBottom: 6 }}>
              {editId === c._id ? (
                <>
                  <input value={editForm.icone} onChange={(e) => setEditForm((f) => ({ ...f, icone: e.target.value }))} style={{ ...inp, width: 50, textAlign: "center", padding: "6px" }} />
                  <input value={editForm.nome} onChange={(e) => setEditForm((f) => ({ ...f, nome: e.target.value }))} style={{ ...inp, flex: 1, padding: "6px 10px" }} />
                  <input type="color" value={editForm.cor} onChange={(e) => setEditForm((f) => ({ ...f, cor: e.target.value }))} style={{ width: 32, height: 32, border: "none", borderRadius: 6, cursor: "pointer", background: "none" }} />
                  <button onClick={() => salvarEdicao(c._id)} style={{ background: "#10b981", border: "none", borderRadius: 6, padding: "6px 12px", color: "#fff", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>OK</button>
                  <button onClick={() => setEditId(null)} style={{ background: "none", border: "none", color: theme.textMuted, fontSize: 18, cursor: "pointer" }}>×</button>
                </>
              ) : (
                <>
                  <span style={{ fontSize: 18 }}>{c.icone}</span>
                  <span style={{ width: 14, height: 14, borderRadius: 4, background: c.cor, flexShrink: 0 }} />
                  <span style={{ flex: 1, fontSize: 14, color: theme.text, fontWeight: 600 }}>{c.nome}</span>
                  <button onClick={() => { setEditId(c._id); setEditForm({ nome: c.nome, cor: c.cor || "#0ea5e9", icone: c.icone || "💰" }); }} style={{ background: "none", border: `1px solid ${theme.border}`, borderRadius: 6, padding: "4px 10px", color: theme.textMuted, fontSize: 12, cursor: "pointer" }}>Editar</button>
                  <button onClick={() => excluir(c._id, c.nome)} style={{ background: "none", border: "none", color: "#ef4444", fontSize: 16, cursor: "pointer" }}>🗑️</button>
                </>
              )}
            </div>
          ))}
          {lista.length === 0 && <div style={{ fontSize: 13, color: theme.textMuted, textAlign: "center", padding: 20 }}>Nenhuma categoria ainda.</div>}
        </div>
        <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: theme.textMuted, marginBottom: 10, textTransform: "uppercase", letterSpacing: ".04em" }}>Nova categoria</div>
          <input value={novo.nome} onChange={(e) => setNovo((n) => ({ ...n, nome: e.target.value }))} placeholder="Nome da categoria" style={{ ...inp, marginBottom: 10 }} />
          <div style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 11, color: theme.textMuted, marginBottom: 6 }}>Ícone</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {ICONES.map((ic) => (
                <button key={ic} onClick={() => setNovo((n) => ({ ...n, icone: ic }))} style={{ fontSize: 18, width: 36, height: 36, borderRadius: 8, border: `2px solid ${novo.icone === ic ? ORANGE : theme.border}`, background: novo.icone === ic ? ORANGE + "18" : "transparent", cursor: "pointer" }}>{ic}</button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: theme.textMuted, marginBottom: 6 }}>Cor</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {CORES.map((c) => (
                <button key={c} onClick={() => setNovo((n) => ({ ...n, cor: c }))} style={{ width: 28, height: 28, borderRadius: 6, background: c, border: novo.cor === c ? "3px solid " + theme.text : "3px solid transparent", cursor: "pointer" }} />
              ))}
            </div>
          </div>
          <button onClick={adicionar} disabled={load || !novo.nome.trim()} style={{ width: "100%", background: ORANGE, border: "none", borderRadius: 10, padding: "12px 0", color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer", opacity: (load || !novo.nome.trim()) ? .5 : 1 }}>{load ? "Adicionando..." : "+ Adicionar categoria"}</button>
        </div>
      </div>
    </div>
  );
}
